// Reports list and pivot builder (redesign 2026-10). English only for now.
import type { Phrase } from '../staffText'

const en = (text: string): Phrase => ({ en: text, az: '', ru: '' })

export const pivot = {
  'pivot.newReport': en('New report'),
  'pivot.editReport': en('Edit report'),
  'pivot.schedules': en('Schedules'),
  'pivot.schedule': en('Schedule'),
  'pivot.allReports': en('All reports'),
  'pivot.oneReport': en('1 report'),
  'pivot.nReports': en('{n} reports'),
  'pivot.searchReports': en('Search reports…'),
  'pivot.sort': en('Sort'),
  'pivot.sortUpdated': en('Recently updated'),
  'pivot.sortCreated': en('Recently created'),
  'pivot.sortName': en('Name (A–Z)'),
  'pivot.no': en('No.'),
  'pivot.name': en('Name'),
  'pivot.description': en('Description'),
  'pivot.createdBy': en('Created by'),
  'pivot.created': en('Created'),
  'pivot.updated': en('Updated'),
  'pivot.actions': en('Actions'),
  'pivot.actionsFor': en('Actions for {name}'),
  'pivot.builtIn': en('Built-in'),
  'pivot.qmeter': en('Qmeter'),
  'pivot.you': en('You'),
  'pivot.formerStaff': en('Former staff'),
  'pivot.noReports': en('No reports yet'),
  'pivot.noMatch': en('No reports match'),
  'pivot.open': en('Open'),
  'pivot.edit': en('Edit'),
  'pivot.duplicate': en('Duplicate'),
  'pivot.takeOver': en('Take over'),
  'pivot.duplicated': en('Copied to your reports'),
  'pivot.copyName': en('{name} copy'),
  'pivot.copyNameN': en('{name} copy {n}'),
  'pivot.yoursNow': en('The report is yours now'),
  'pivot.saved': en('Report saved'),
  'pivot.savedState': en('Saved'),
  'pivot.deleted': en('Report deleted'),
  'pivot.continue': en('Continue'),
  'pivot.nameNeeded': en('Give the report a name.'),
  'pivot.deleteAsk': en('Delete “{name}”?'),
  'pivot.deleteNote': en('Its layout goes for good.'),
  'pivot.leaveAsk': en('Leave without saving?'),
  'pivot.leaveNote': en('Your changes to this report are not saved.'),
  'pivot.stay': en('Stay'),
  'pivot.leave': en('Leave'),

  'pivot.bi.overview': en('Overview'),
  'pivot.bi.overviewAbout': en('Tickets, waiting and service level by service'),
  'pivot.bi.branches': en('Branches'),
  'pivot.bi.branchesAbout': en('Tickets, waiting and service level by branch'),
  'pivot.bi.hours': en('By hour'),
  'pivot.bi.hoursAbout': en('Tickets by hour of the day'),
  'pivot.bi.peak15': en('Peak 15 minutes'),
  'pivot.bi.peak15About': en('Tickets per 15 minutes'),
  'pivot.bi.weekdays': en('Days of the week'),
  'pivot.bi.weekdaysAbout': en('Tickets and service level by weekday'),
  'pivot.bi.channels': en('How they came'),
  'pivot.bi.channelsAbout': en('Tickets by channel and source'),
  'pivot.bi.waits': en('How long they wait'),
  'pivot.bi.waitsAbout': en('Tickets by wait band'),
  'pivot.bi.compare': en('Against the period before'),
  'pivot.bi.compareAbout': en('This month beside last month'),
  'pivot.bi.desks': en('Counters'),
  'pivot.bi.desksAbout': en('Served and handling time by counter'),
  'pivot.bi.staff': en('Staff'),
  'pivot.bi.staffAbout': en('Served and handling time by person'),
  'pivot.bi.breaks': en('Breaks'),
  'pivot.bi.breaksAbout': en('Lunch, short breaks and tasks'),
  'pivot.bi.weekly': en('Week by week'),
  'pivot.bi.weeklyAbout': en('The last 12 weeks'),
  'pivot.bi.monthly': en('Month by month'),
  'pivot.bi.monthlyAbout': en('The last 12 months'),
  'pivot.bi.tickets': en('Tickets'),
  'pivot.bi.ticketsAbout': en('Every piece of work, one row each'),
  'pivot.bi.bookings': en('Bookings'),
  'pivot.bi.bookingsAbout': en('Booked, arrived and on time'),
  'pivot.bi.estimates': en('Wait estimates'),
  'pivot.bi.estimatesAbout': en('Waits told against waits had'),

  'pivot.breaks.count': en('Breaks'),
  'pivot.breaks.total': en('Total time'),
  'pivot.breaks.employee': en('Employee'),
  'pivot.breaks.allEmployees': en('All employees'),
  'pivot.breaks.kind': en('Kind'),
  'pivot.breaks.allKinds': en('All kinds'),
  'pivot.breaks.counter': en('Counter'),
  'pivot.breaks.reason': en('Reason'),
  'pivot.breaks.start': en('Start'),
  'pivot.breaks.end': en('End'),
  'pivot.breaks.time': en('Time'),
  'pivot.breaks.decidedBy': en('Decided by'),
  'pivot.breaks.running': en('Running'),
  'pivot.breaks.none': en('No breaks in this period'),

  'pivot.breadcrumb': en('Breadcrumb'),
  'pivot.loading': en('Loading…'),
  'pivot.gone': en('This report no longer exists'),
  'pivot.draft': en('Draft'),
  'pivot.viewOnlyBy': en('By {owner} · view only'),
  'pivot.builtInViewOnly': en('Built-in · view only'),
  'pivot.lastRun': en('Last run'),
  'pivot.secondsAgo': en('{n}s ago'),
  'pivot.scanned': en('{n} rows scanned'),
  'pivot.metaHint': en('Drag dimensions into Rows or Columns and measures into Values, then Run.'),
  'pivot.branch': en('Branch'),
  'pivot.branches': en('Branches'),
  'pivot.allBranches': en('All branches'),
  'pivot.export': en('Export'),
  'pivot.excel': en('Excel (.xlsx)'),
  'pivot.csv': en('CSV (.csv)'),
  'pivot.exporting': en('Preparing the file'),
  'pivot.saveChanges': en('Save changes'),
  'pivot.duplicateToEdit': en('Duplicate to edit'),
  'pivot.fieldGone': en('{field} is no longer offered'),
  'pivot.layout': en('Report layout'),
  'pivot.rows': en('Rows'),
  'pivot.columns': en('Columns'),
  'pivot.values': en('Values'),
  'pivot.available': en('Available'),
  'pivot.measures': en('Measures'),
  'pivot.findField': en('Find a field'),
  'pivot.noField': en('No field matches'),
  'pivot.dropDimension': en('Drop a dimension here'),
  'pivot.dropMeasure': en('Drop a measure here'),
  'pivot.placedChip': en('{field}, in {zone}'),
  'pivot.dragHint': en('Drag into a zone, or double-click to add'),
  'pivot.remove': en('Remove {field}'),
  'pivot.add': en('Add {field}'),
  'pivot.move': en('Move {field}'),
  'pivot.moveRows': en('Move to Rows'),
  'pivot.moveCols': en('Move to Columns'),
  'pivot.moveUp': en('Move up'),
  'pivot.moveDown': en('Move down'),
  'pivot.removeShort': en('Remove'),
  'pivot.measuresOnly': en('Only measures go into Values'),
  'pivot.dimsOnly': en('Measures go into Values'),
  'pivot.tooManyFields': en('That zone is full'),
  'pivot.tooManyValues': en('Values holds at most 8'),
  'pivot.filter': en('Filter {field}'),
  'pivot.filterShort': en('Filter'),
  'pivot.groupBy': en('Group by'),
  'pivot.group.day': en('Day'),
  'pivot.group.week': en('Week'),
  'pivot.group.month': en('Month'),
  'pivot.group.quarter': en('Quarter'),
  'pivot.group.year': en('Year'),
  'pivot.searchValues': en('Search…'),
  'pivot.selectAll': en('Select all'),
  'pivot.clear': en('Clear'),
  'pivot.apply': en('Apply'),
  'pivot.valuesFailed': en('The values could not be loaded.'),
  'pivot.noValues': en('No values'),
  'pivot.run': en('Run report'),
  'pivot.runNeedsValue': en('Add a field first'),
  'pivot.running': en('Running report…'),
  'pivot.oneFilter': en('1 filter active'),
  'pivot.nFilters': en('{n} filters active'),
  'pivot.nValues': en('{n} values'),
  'pivot.notValue': en('not {value}'),
  'pivot.removeFilter': en('Remove filter {filter}'),
  'pivot.noData': en('No data yet'),
  'pivot.readyToRun': en('Ready to run'),
  'pivot.tryAgain': en('Try again'),
  'pivot.noRows': en('No rows in the result'),
  'pivot.noRowsHint': en('Clear a filter or widen the dates.'),
  'pivot.tooWide': en('Too many columns. Move a field to Rows or add a filter.'),
  'pivot.tooMuch': en('Too much to read at once. Narrow the dates or branches.'),
  'pivot.result': en('Report result'),
  'pivot.total': en('Total'),
  'pivot.grandTotal': en('Grand total'),
  'pivot.allTickets': en('All tickets'),
  'pivot.truncated': en('Showing the first {shown} of {n} rows. Narrow the filters, or Export for all of them.'),
  'pivot.footer': en('{rows} rows · {tickets} tickets · Right-click any cell to filter; drag dimensions to rearrange.'),
  'pivot.footerRead': en('{rows} rows · {tickets} tickets'),
  'pivot.emptyReport': en('This report is empty'),
  'pivot.cellMenu': en('Filter by this cell'),
  'pivot.keepOnly': en('Keep only'),
  'pivot.exclude': en('Exclude'),
  'pivot.showAll': en('Show all'),
  'pivot.dateRange': en('Date range'),
  'pivot.custom': en('Custom…'),
  'pivot.from': en('From'),
  'pivot.to': en('To'),
  'pivot.date.today': en('Today'),
  'pivot.date.yesterday': en('Yesterday'),
  'pivot.date.last7': en('Last 7 days'),
  'pivot.date.last30': en('Last 30 days'),
  'pivot.date.thisWeek': en('This week'),
  'pivot.date.lastWeek': en('Last week'),
  'pivot.date.thisMonth': en('This month'),
  'pivot.date.lastMonth': en('Last month'),
  'pivot.date.twoMonths': en('This and last month'),
  'pivot.date.weeks12': en('Last 12 weeks'),
  'pivot.date.months12': en('Last 12 months'),

  'pivot.newSchedule': en('New schedule'),
  'pivot.editSchedule': en('Edit schedule'),
  'pivot.deleteSchedule': en('Delete schedule'),
  'pivot.noSchedules': en('No schedules yet.'),
  'pivot.pause': en('Pause'),
  'pivot.resume': en('Resume'),
  'pivot.pausedWord': en('paused'),
  'pivot.paused': en('Schedule paused'),
  'pivot.resumed': en('Schedule resumed'),
  'pivot.scheduleCreated': en('Schedule created'),
  'pivot.scheduleSaved': en('Schedule saved'),
  'pivot.scheduleDeleted': en('Schedule deleted'),
  'pivot.create': en('Create'),
  'pivot.timeNeeded': en('Write the time as HH:MM.'),
  'pivot.recipientsHint': en('name@bank.az, another@bank.az'),
  'pivot.covers.daily': en('Sends yesterday.'),
  'pivot.covers.weekly': en('Sends last week, on Mondays.'),
  'pivot.covers.monthly': en('Sends last month, on the 1st.'),
}
